<script lang="ts">
import { defineComponent, watch } from 'vue'

export default defineComponent({
  props: {
    open: Boolean,
  },
  emits: ['open', 'close'],
  setup(props, { emit }) {
    watch(() => props.open, (open) => {
      if (open)
        emit('open')
      else
        emit('close')
    })
  },
  render: () => null,
})
</script>
